<template>
  <div>
    <div
      :class="isStagingEnv ? 'draggable-view stage-bg' : 'draggable-view'"
      :style="buttonStyle"
      @mousedown="startDrag"
    >
      <i class="el-icon-rank" />
      <div
        class="button"
        @mousedown.stop.prevent
        @click="handleChangeGatewayEnv"
      >
        切换{{ isStagingEnv ? "预发布" : "测试" }}环境
      </div>
    </div>
    <EnvModal v-model="isShowModalEnv" />
  </div>
</template>
<script>
import EnvModal from "@/components/EnvModal/index.vue";

export default {
  name: "FloatButton",
  components: { EnvModal },
  data() {
    return {
      isDragging: false,
      startX: 0,
      startY: 0,
      dragStartTime: 0,
      padding: 24,
      buttonStyle: {
        left: "0px",
        top: "0px",
      },
      isShowModalEnv: false,
    };
  },
  computed: {
    /**
     * 是否是staging环境
     * @returns {boolean}
     */
    isStagingEnv() {
      return process.env.NODE_ENV === "staging";
    },
  },
  mounted() {
    this.setInitialPosition();
    window.addEventListener("resize", this.setInitialPosition);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setInitialPosition);
  },
  methods: {
    setInitialPosition() {
      this.buttonStyle.top = `${this.padding}px`;
      this.buttonStyle.left = `${window.innerWidth / 2 - this.padding}px`;
    },
    startDrag(event) {
      this.isDragging = true;
      this.dragStartTime = new Date().getTime();
      this.startX = event.clientX - parseInt(this.buttonStyle.left, 10);
      this.startY = event.clientY - parseInt(this.buttonStyle.top, 10);

      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    },
    onDrag(event) {
      if (this.isDragging) {
        let newLeft = event.clientX - this.startX;
        let newTop = event.clientY - this.startY;

        // 确保按钮不会上下超出屏幕
        const buttonWidth = 140;
        const buttonHeight = 40;
        const maxWidth = window.innerWidth - buttonWidth - this.padding;
        const maxHeight = window.innerHeight - buttonHeight - this.padding;

        if (newLeft < this.padding) {
          newLeft = this.padding;
        } else if (newLeft > maxWidth) {
          newLeft = maxWidth;
        }

        if (newTop < this.padding) {
          newTop = this.padding;
        } else if (newTop > maxHeight) {
          newTop = maxHeight;
        }

        this.buttonStyle.left = `${newLeft}px`;
        this.buttonStyle.top = `${newTop}px`;
      }
    },
    stopDrag() {
      this.isDragging = false;
      const dragEndTime = new Date().getTime();

      // 判断是否为点击事件
      if (dragEndTime - this.dragStartTime < 200) {
        // 拖拽时间少于200ms认为是点击事件，直接返回
        document.removeEventListener("mousemove", this.onDrag);
        document.removeEventListener("mouseup", this.stopDrag);
        return;
      }

      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
    },
    handleChangeGatewayEnv() {
      this.isShowModalEnv = true;
    },
  },
};
</script>
<style lang="less" scoped>
.draggable-view {
  box-sizing: border-box;
  width: 140px;
  height: 40px;
  padding: 0 8px;
  background-color: #40a9ff;
  border-radius: 4px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  user-select: none;
  z-index: 999;
  cursor: grab;

  .button {
    cursor: pointer;
  }
}

.stage-bg {
  background-color: #f13685;
}
</style>



// WEBPACK FOOTER //
// src/components/FloatButton/index.vue